import { Pipe, PipeTransform } from '@angular/core';

import { LocaleService } from '@lib/translation';

@Pipe({
  name: 'snFilesize',
  pure: false,
})
export class SnFilesizePipe implements PipeTransform {
  constructor(private readonly _localeService: LocaleService) {}

  public transform(size: number): string {
    const fileSize = ['B', 'KB', 'MB', 'GB'];
    const base = Math.trunc(Math.log(size) / Math.log(1000));
    const value = size / Math.pow(1000, base);
    const formattedValue = this._localeService.formatNumber(value, 2, 2);
    
    return formattedValue + ' ' + fileSize[base];
  }
}
